"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var react_router_dom_2 = require("react-router-dom");
var Button_1 = __importDefault(require("../../components/Button"));
var NotFoundFooter_1 = __importDefault(require("../../components/AppFooter/NotFoundFooter"));
var Routes_1 = require("../../constants/Routes");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var react_redux_1 = require("react-redux");
var globalSlice_1 = require("../../features/global/globalSlice");
var NotFound = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var location = react_router_dom_1.useLocation();
    var dispatch = react_redux_1.useDispatch();
    react_1.useEffect(function () {
        return function () {
            dispatch(globalSlice_1.setIsPageNotFound(false));
        };
    }, [location]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.not_found },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("h1", { className: styles_module_scss_1.default.title }, t('NOT_FOUND.TITLE')),
                react_1.default.createElement("p", { className: styles_module_scss_1.default.info }, t('NOT_FOUND.CONTENT')),
                react_1.default.createElement(react_router_dom_2.Link, { to: Routes_1.Routes.Home.path },
                    react_1.default.createElement(Button_1.default, { variant: "outline" }, t('NOT_FOUND.BACK_TO_HOME')))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.footer },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.image }),
                react_1.default.createElement(NotFoundFooter_1.default, null)))));
};
exports.default = NotFound;
